import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "@/widgets/MarketplaceReviews/Icons/StarRounded.vue";
import { ref, watch } from "vue";

/* NOTE:
  This component uses only for correct working `StarRounded` component as prop.
  Options-API in ImageUpload.vue cannot set component as prop into another component
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    modelValue: { default: () => {
      return 0;
    } }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const rating = ref<number>(props.modelValue);
function setRating(option: number) {
  emit("update:modelValue", option);

  rating.value = option;
}

watch(
  () => props.modelValue,
  (value) => {
    rating.value = value;
  }
);

watch(rating, (value) => {
  setRating(Math.ceil(value));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Vue3StarRating), {
    modelValue: rating.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rating).value = $event)),
    numberOfStars: 5,
    starSize: 39,
    starColor: '#606266',
    inactiveColor: '#E9E9EB',
    disableClick: false,
    customSvg: StarRounded
  }, null, 8, ["modelValue"]))
}
}

})